export enum DateFormats {
  SHORT_DATE = 'yyyy-MM-dd',
  KH_SHORTEST = 'kh_ll',
  LT = 't',
  LL = 'LL',
  LL_SHORT = 'll',
  DAY_OF_WEEK_SHORT = 'dd',
  DAY_OF_WEEK_MEDIUM = 'ddd',
  DAY_OF_WEEK_FULL = 'dddd',
  MONTH_SHORT = 'MM',
  MONTH_MEDIUM = 'MMM',
  MONTH_FULL = 'MMMM',
  MONTH_DATE_MEDIUM_POINT = 'MMM. d',
  TIME_SHORT = 'h:mm a'
}
